// src/ui/features/calculator/components/ModulesPanel.jsx
import React from "react";
import YearAccordion from "./YearAccordion";

export default function ModulesPanel({
  ruleset,
  loading,
  loadError,

  levels,
  modulesByLevel,
  totals,
  requiredCreditsByLevel,
  minGrade,

  openLevelKey,
  setOpenLevelKey,

  addModule,
  updateModule,
  clampAndAnalyse,
  removeModule,

  error,

  onLoadPresetLevel,
  onClearAllLevel,
}) {
  return (
    <div className="space-y-4">
      {ruleset && !loading && !loadError
        ? levels.map((lvl, idx) => {
            const levelKey = lvl.key;
            const modules = modulesByLevel[levelKey] || [];
            const total = totals[levelKey] || 0;
            const required = requiredCreditsByLevel[levelKey] || 0;

            return (
              <YearAccordion
                key={levelKey}
                yearIndex={idx + 1}
                levelKey={levelKey}
                required={required}
                total={total}
                modules={modules}
                minGrade={minGrade}
                isOpen={openLevelKey === levelKey}
                onToggle={() => setOpenLevelKey((k) => (k === levelKey ? null : levelKey))}
                onAddModule={() => addModule(levelKey)}
                onUpdateModule={(mIdx, field, value) => updateModule(levelKey, mIdx, field, value)}
                onClampModule={(mIdx, field) => clampAndAnalyse(levelKey, mIdx, field)}
                onRemoveModule={(mIdx) => removeModule(levelKey, mIdx)}
                onLoadPreset={() => onLoadPresetLevel?.(levelKey, required)}
                onClearAll={() => onClearAllLevel?.(levelKey)}
              />
            );
          })
        : null}

      {error ? (
        <div className="rounded-2xl border border-red-200 bg-red-50 p-4 text-sm text-red-800 dark:border-red-900/40 dark:bg-red-950/40 dark:text-red-200">
          {error}
        </div>
      ) : null}
    </div>
  );
}
